import { Routes, Route } from 'react-router-dom'
import ProtectedRoute from '@/components/ProtectedRoute'
import AdminLayout from '@/components/AdminLayout'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Dashboard from '@/pages/Dashboard'
import BookingList from '@/pages/bookings/index'
import ServiceList from '@/pages/services/index'
import CustomerList from '@/pages/customers/index'
import SystemUserList from '@/pages/system-users/index'
import HomepagePage from '@/pages/homepage/index'
import ContactPage from '@/pages/contact/index'
import FaqsPage from '@/pages/faqs/index'
import DepartmentList from '@/pages/departments/index'
import DoctorList from '@/pages/doctors/index'
import RoomList from '@/pages/rooms/index'
import RoomBookingList from '@/pages/room-bookings/index'
import PackageList from '@/pages/packages/index'
import AboutPage from '@/pages/about/index'
import InsurancePage from '@/pages/insurance/index'
import NewsList from '@/pages/news/index'
import BranchesPage from '@/pages/branches/index'
import SvcCategoryList from '@/pages/svc-categories/index'
import CareersPage from '@/pages/careers/index'
import SurveyPage from '@/pages/survey/index'
import ReferralLetterPage from '@/pages/referral-letter/index'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="bookings" element={<BookingList />} />
          <Route path="departments" element={<DepartmentList />} />
          <Route path="doctors" element={<DoctorList />} />
          <Route path="services" element={<ServiceList />} />
          <Route path="svc-categories" element={<SvcCategoryList />} />
          <Route path="rooms" element={<RoomList />} />
          <Route path="room-bookings" element={<RoomBookingList />} />
          <Route path="packages" element={<PackageList />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="insurance" element={<InsurancePage />} />
          <Route path="customers" element={<CustomerList />} />
          <Route path="system-users" element={<SystemUserList />} />
          <Route path="homepage" element={<HomepagePage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="faqs" element={<FaqsPage />} />
          <Route path="news" element={<NewsList />} />
          <Route path="careers" element={<CareersPage />} />
          <Route path="survey" element={<SurveyPage />} />
          <Route path="referral-letter" element={<ReferralLetterPage />} />
          <Route path="branches" element={<BranchesPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
